import React from "react";
import Dialog from "@material-ui/core/Dialog";

// Claude Design "CMP Accelerator Member Dashboard" (Oct 16 2026) popup shell:
// result popups of Manage Company Profile (CHANGES SAVED, MISSING REQUIRED
// FIELDS, ...) and the UNSAVED CHANGES popup. Chamber Member Pro members only.

export const CMP_POPUP_COLORS = { gold: "#E1A731", goldDark: "#C6912A", black: "#0A0A0A", red: "#ED1C24", green: "#10B981", text: "#000000" };

export const CmpPopupIcon = ({ tone }: { tone: "success" | "warning" }) => (
    <div style={{ width: 56, height: 56, borderRadius: "50%", background: tone === "success" ? CMP_POPUP_COLORS.green : CMP_POPUP_COLORS.red,
        display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
        {tone === "success" ? (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5" /></svg>
        ) : (
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                <path d="M10.3 3.9L1.8 18a2 2 0 0 0 1.7 3h17a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" /><path d="M12 9v4" /><path d="M12 17h.01" />
            </svg>
        )}
    </div>
);

export const cmpPopupButton = (background: string): React.CSSProperties => ({
    background, color: "#FFFFFF", border: "none", borderRadius: 8, padding: "12px 16px", fontFamily: "'DM Sans', sans-serif",
    fontSize: 14, fontWeight: 600, cursor: "pointer",
});

export const CmpPopup = ({ label, tone, title, onClose, children }: {
    label: string; tone: "success" | "warning"; title: string; onClose: () => void; children?: React.ReactNode;
}) => (
    <Dialog open onClose={onClose} aria-label={label} maxWidth={false} style={{ zIndex: 1400 }}
        PaperProps={{ style: { width: "min(460px, 92vw)", maxHeight: "90vh", overflowY: "auto", borderRadius: 16, margin: 0, position: "relative",
            padding: "32px 32px 28px", boxSizing: "border-box", boxShadow: "0 8px 30px rgba(0,0,0,.12)", display: "flex", flexDirection: "column",
            alignItems: "center", textAlign: "center", fontFamily: "'DM Sans', sans-serif", color: CMP_POPUP_COLORS.text } }}>
        <button type="button" aria-label="Close" onClick={onClose} style={{ position: "absolute", top: 14, right: 14, width: 28, height: 28, borderRadius: "50%",
            background: CMP_POPUP_COLORS.red, color: "#FFFFFF", border: "none", cursor: "pointer", display: "flex", alignItems: "center", justifyContent: "center", padding: 0 }}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2 2l8 8M10 2l-8 8" stroke="#fff" strokeWidth="2" strokeLinecap="round" /></svg>
        </button>
        <CmpPopupIcon tone={tone} />
        <div style={{ fontSize: 18, fontWeight: 700, marginTop: 18, letterSpacing: "0.01em" }}>{title}</div>
        {children}
    </Dialog>
);
